export default {  

    end: "Votre profil Farmer 4.0",

    profile: "Votre profil",

    restart: "Redémarrer le quiz",

    submit: "Soumettre",

    print: "Téléchargez votre profil en PDF",

    data: "Vos données",

    progress: "Progress",

    confirm: {

        restart: 'Êtes-vous sûrs de PERDRE toutes vos données et recommencer le test?'

    },

    steps: {

        "0-1": "L'ÉVALUATION DU NIVEAU D'ÉDUCATION",

        "0-2": "UNE EXPÉRIENCE D'ENTREPRENEUR EN AGRICULTURE",

        "1-1": "IDENTIFICATION DES EXPÉRIENCES PASSÉES DANS LE DOMAINE DE L'AGRICULTURE",

        "1-2": "IDENTIFICATION DES EXPÉRIENCES PASSÉES DANS LE DOMAINE DE L'AGRICULTURE",

        "1-3": "IDENTIFICATION DES EXPÉRIENCES PASSÉES DANS LE DOMAINE DE L'AGRICULTURE",

        "1-4": "IDENTIFICATION DES EXPÉRIENCES PASSÉES DANS LE DOMAINE DE L'AGRICULTURE",

        "2": "LA PROPENSION À L'ESPRIT D'ENTREPRISE",

        "3-1": "LES COMPÉTENCES RELATIONNELLES POUR RÉUSSIR EN TANT QU'ENTREPRENEUR - LA CRÉATIVITÉ",

        "3-2": "COMPÉTENCES RELATIONNELLES POUR RÉUSSIR EN TANT QU'ENTREPRENEUR - COMMUNICATION - PARTIE 1",

        "3-3": "COMPÉTENCES RELATIONNELLES POUR RÉUSSIR EN TANT QU'ENTREPRENEUR - COMMUNICATION - PARTIE 2",

        "3-4": "COMPÉTENCES RELATIONNELLES POUR RÉUSSIR EN TANT QU'ENTREPRENEUR - COMMUNICATION - PARTIE 3",

        "3-5": "COMPÉTENCES RELATIONNELLES POUR RÉUSSIR EN TANT QU'ENTREPRENEUR - COMMUNICATION - PARTIE 4",

        "4-1": "COMPÉTENCES EN MATIÈRE DE TIC - COMPÉTENCES CLÉS",

        "4-2-1": "COMPETENCES ICT FARMER 4.0",

        "4-2-2": "COMPETENCES ICT FARMER 4.0",

        "4-2-3": "COMPETENCES ICT FARMER 4.0",

        "4-2-4": "COMPETENCES ICT FARMER 4.0",

        "4-2-5": "COMPETENCES ICT FARMER 4.0",

        "4-2-6": "COMPETENCES ICT FARMER 4.0",

        "5-1": "AUTRES COMPÉTENCES PROFESSIONNELLES POUR ÊTRE AGRICULTEUR 4.0",

        "5-2": "AUTRES COMPÉTENCES PROFESSIONNELLES POUR ÊTRE AGRICULTEUR 4.0",

        "5-3": "AUTRES COMPÉTENCES PROFESSIONNELLES POUR ÊTRE AGRICULTEUR 4.0",

    },

    questions: {

        "0-1-1" : "Sélectionnez votre niveau d'études", 

        "0-2-1" : "Quel est le domaine dans lequel vous êtes/voudriez être un entrepreneur en agriculture ?",

        "1-1-1" : "Avez-vous une expérience préalable en tant qu'entrepreneur dans le domaine de l'agriculture ?",

        "1-2-1" : "Avez-vous d'autres types d'expériences dans le domaine agricole et souhaitez-vous devenir entrepreneur ?",

        "1-3-1" : "Quelles sont vos autres expériences antérieures dans le domaine de l'agriculture ?",

        "1-4-1" : "Combien de temps avez-vous passé à ce poste ?",

        "1-4-2" : "Depuis combien de temps avez-vous acquis cette expérience ?",

        "2-1" : "Je suis prêt à travailler régulièrement 50 heures ou plus par semaine.",

        "2-2" : "Ma famille me soutiendra dans mon entreprise. Ma famille soutiendra mon souhait de créer une entreprise",

        "2-3" : "Je suis prêt à accepter des risques financiers et professionnels si nécessaire.",

        "2-4" : "Je n'ai pas besoin de tous les avantages annexes que procure un emploi régulier (par exemple, cotisations de retraite, congés payés)",

        "2-5" : "Je suis prêt à assumer l'entière responsabilité des succès et/ou des échecs de mon entreprise",

        "2-6" : "J'aurai plus de succès financier en ayant ma propre entreprise. La possibilité de réussite financière est plus élevée si je possède ma propre entreprise.",

        "2-7" : "Je ressens une grande fierté lorsque je mène à bien un projet.",

        "2-8" : "J'ai un niveau d'énergie élevé qui peut être maintenu sur une longue période.",

        "2-9" : "J'aime avoir le contrôle sur mes propres missions et sur les décisions qui affectent mon travail.",

        "2-10" : "Je crois que je suis responsable de mes propres succès et échecs.",

        "2-11" : "Je souhaite vivement obtenir des résultats positifs, même si cela demande beaucoup d'efforts supplémentaires.",

        "2-12" : "Je comprends bien comment gérer une entreprise.",

        "2-13" : "Je peux agir dans des situations où les choses changent rapidement",

        "2-14" : "L'un de mes parents ou les deux étaient des entrepreneurs.",

        "2-15" : "Je crois que j'ai de meilleures capacités et compétences que les autres avec qui j'ai travaillé",

        "2-16" : "Les gens me font confiance et me considèrent comme honnête et fiable.",

        "2-17" : "J'essaie toujours de mener à bien chaque projet que je lance, quels que soient les obstacles et les difficultés que je rencontre.",

        "2-18" : "Je suis prêt à faire quelque chose même si les autres rient ou me critiquent pour l'avoir fait.",

        "2-19" : "Je peux prendre des décisions rapidement.",

        "2-20" : "Je dispose d'un bon réseau d'amis, de professionnels et de relations d'affaires.",

        "3-1-1" : "Lorsque je suis confronté à un problème au travail, j'aime trouver plusieurs solutions alternatives possibles.",

        "3-1-2": "Si je reçois une nouvelle mission, je préfère suivre attentivement les instructions afin d'éviter tout problème",

        "3-1-3": "Quand je vois quelque chose d'étrange et d'inhabituel, je préfère ne pas m'en mêler pour éviter les désagréments?", 

        "3-1-4": "Dans une discussion, j'aime écouter les idées des autres, même si je n'ai pas/ne partage pas les mêmes idées. ",

        "3-1-5": "Lorsque les choses ne sont pas claires, je demande des explications pour mieux comprendre",

        "3-1-6": "Lorsque je dois faire un travail répétitif, je cherche généralement différentes façons de terminer la tâche (soit pour trouver une méthode plus rapide, une nouvelle méthode ou pour m'assurer qu'elle n'est pas inutile), de la faire plus vite, de la faire d'une nouvelle façon, ou même de réaliser si je ne devrais pas la faire parce qu'elle est inutile)",

        "3-1-7": "Je préfère raisonner avec \"logique et rationalité\", en laissant de côté les arguments émotionnels et impulsifs.",

        "3-1-8": "J'aime les nouveaux défis - ils me motivent à faire de mon mieux",

        "3-1-9": "J'aime jouer avec les idées",

        "3-1-10": "Je suis d'accord avec cette déclaration : \"la copie est utile car elle permet l'innovation\"",

        "3-1-11": "Dans les situations complexes, je m'adresse à des experts ou à ceux que je considère comme des experts",

        "3-1-12": "Pour convaincre les autres que mon idée est bonne, je suis prêt à me battre, à expliquer et à prouver la valeur de mon idée",

        "3-1-13": "L'anarchie, à petites doses, est un puissant outil d'innovation",

        "3-1-14": "Je commence des tâches sans les avoir entièrement achevées",

        "3-1-15": "Il est impossible d'être créatif dans le travail de bureau",

        "3-1-16": "Si je change d'emploi, je préfère un emploi comportant des tâches routinières ou dans lequel je sais quelles tâches je dois accomplir.",

        "3-1-17": "Quand il y a des situations compliquées au travail, j'essaie de ne pas trop y penser. Je fais appel à mon intuition pour trouver une solution.",

        "3-1-18": "Je ne crois pas que les aspects de gestion et de comptabilité d'une tâche soient importants et je concentrerais cette attention sur les priorités stratégiques",

        "3-1-19": "Je préfère la phase créative d'une tâche parce que je peux coopérer avec d'autres pour produire de nouvelles idées.",

        "3-1-20": "Je préfère les arts/humanités aux sciences naturelles/financières",

        "3-1-21": "Je suis ouvert au fait qu'il peut y avoir d'autres moyens d'atteindre le résultat souhaité.",

        "3-1-22": "Être innovant au travail est une limitation. Il est préférable d'être d'accord avec le reste du groupe.",

        "3-1-23": "Lorsque je choisis un restaurant ou un bar, je préfère ceux que je connais déjà parce que je sais ce que je vais obtenir. ",

        "3-1-24": "Même dans les situations graves et critiques, j'aime à penser qu'il y a une solution possible. Il suffit de la chercher. Cela ne sert à rien de perdre espoir.",

        "3-1-25": "Je connais et j'applique des méthodes et des techniques pour développer la créativité au travail.",

        "3-2-1": "Je peux impressionner la personne qui me parle",

        "3-2-2": "Celui qui parle le plus est plus fort dans la discussion",

        "3-2-3": "Je sais comment faire passer mes idées ?",

        "3-2-4": "Je me sens à l'aise dans les discussions",

        "3-2-5": "Dans une discussion, il y a toujours un gagnant et un perdant",

        "3-2-6": "Je n'ai pas peur d'embarrasser l'autre personne dans la discussion",

        "3-2-7": "Je n'ai peur de personne",

        "3-2-8": "J'aime les contradictions",

        "3-2-9": "Il est nécessaire de pouvoir se mettre en colère",

        "3-2-10": "Dans une discussion que je veux gagner",

        "3-3-1": "Je défends généralement mes idées avec une forte conviction",

        "3-3-2": "Je suis rarement confus",

        "3-3-3": "Je peux défendre une idée avec laquelle je ne suis pas d'accord",

        "3-3-4": "J'essaie de comprendre ce que l'autre personne essaie d'accomplir/les intentions de l'autre personne.",

        "3-3-5": "Je me sens à l'aise de demander une explication d'une idée ou de déclarer que je n'ai pas compris une idée",

        "3-3-6": "Je suis capable d'attirer l'attention des autres et de les garder engagés",

        "3-3-7": "Je sais que moi et mon interlocuteur pouvons faire des erreurs",

        "3-3-8": "Je défends fermement mes idées",

        "3-3-9": "Je ne cherche pas les conflits, mais je n'en ai pas peur",

        "3-3-10": "Je peux changer d'avis sans me sentir manipulé",

        "3-4-1": "Je rêve souvent",

        "3-4-2": "Souvent, je n'ose pas parler même si je voudrais",

        "3-4-3": "Je préfère ne pas parler de mes idées à certaines personnes",

        "3-4-4": "Parfois, j'oublie ce que je m'apprêtais à dire quand je parle",

        "3-4-5": "Je n'aime pas m'impliquer dans un conflit et essayer de l'éviter ",

        "3-4-6": "Je reste souvent en dehors de la discussion parce que je ne sais pas comment défendre mes idées",

        "3-4-7": "Je me sens mieux de ne pas participer au débat au lieu de me joindre à la lutte",

        "3-4-8": "J'aimerais pouvoir m'affirmer davantage lorsque (exprimer mes besoins avec plus de force)",

        "3-4-9": "Même lorsqu'on me le demande, il est difficile de m'exprimer de manière claire.",

        "3-4-10": "Je parle rarement en premi",

        "3-5-1": "J'évite les conflits parce qu'ils ne mènent à rien",

        "3-5-2": "J'aime utiliser des arguments contradictoires et/ou inattendus",

        "3-5-3": "Il faut pouvoir décourager celui qui parle",

        "3-5-4": "Je laisse les autres parler pour obtenir des informations sur eux",

        "3-5-5": "Je suis bon pour défendre un point de vue avec lequel je ne suis pas d'accord",

        "3-5-6": "Il est plus facile de persuader les gens lorsqu'ils sont complimentés",

        "3-5-7": "Parler en premier est un risque inutile",

        "3-5-8": "Créer une dispute entre les autres personnes participant à la discussion est un bon moyen de contrôler une situation",

        "3-5-9": "Je sais comment cacher mes idées quand je pense que les autres ne sont pas d'accord avec elles",

        "3-5-10": "To cause an argument between the other people in the discussion is a good way to gain control of a situation when I think others don't agree with them",

        "4-1-1": "Utiliser un programme de traitement de texte, par exemple Word, Pages, Writer, Google Docs, etc.",

        "4-1-2": "Utilisation d'un tableur, par exemple Excel, Numbers, Calc, Google Sheets, etc.",

        "4-1-3": "Utiliser l'internet pour trouver des informations",

        "4-1-4": "Utiliser les outils de communication et les médias sociaux, par exemple le courrier électronique, Facebook, LinkedIN,",

        "4-2-1": "Pouvez-vous travailler en CAO?",

        "4-2-2": "Pouvez-vous travailler en CAE?",

        "4-2-3": "Pouvez-vous travailler en CAM",

        "4-2-4": "Pouvez-vous travailler dans le secteur des ER?",

        "4-2-5": "Pouvez-vous travailler dans le domaine de la fabrication d'additifs ?",

        "4-2-6": "Êtes-vous en mesure d'utiliser les médias sociaux (c'est-à-dire facebook, Instagram, Pinterest...) ou un site web pour vous présenter et présenter votre exploitation/activités ou vendre vos produits ?",

        "5-1": "Savez-vous comment créer un réseau d'agriculteurs « numériques » suivant les règles de la GDPR et comment adopter un modèle de gouvernance approprié pour votre exploitation agricole basé sur le concept de FABLAB, en introduisant les technologies 4.0 ?",

        "5-2": "Vous êtes expert en matière d'internationalisation de votre entreprise ?",

        "5-3": "Connaissez-vous l'\"agriculture durable\" et la pratiquez-vous ?",

    },

    answers: {

        "yes": "oui",

        "no": "non",

        "s_agree" : "Tout à fait d'accord",

        "agree": "D’accord",

        "sw_agree": "Plutôt d'accord",

        "disagree" : "En désaccord",

        "s_disagree": "Pas du tout d'accord",

        "never": "Jamais",

        "rarely": "Rarement",

        "often": "Souvent",

        "always": "Toujours",

        "true": "Vrai",

        "false": "Faux",

        "insecure": "Je ne suis pas en sécurité et j'ai besoin d'aide pour utiliser ce type d'outil",

        "confident": "Je me sens assez confiant et je trouve généralement les solutions moi-même lorsque j'utilise cet outil",

        "indipendent": "Je travaille de manière indépendante et confiante et je suis capable d'apprendre aux autres comment utiliser cet outil",

        "dontknow": "Je ne sais pas",   

        "0-1-1-0": "Non instruit",

        "0-1-1-1": "Pas applicable",

        "0-1-1-2": "Pas applicable",

        "0-1-1-3": "Certificat d'aptitude professionnelle – CAP, Brevet d'études professionnelles – BEP, Certificat d'aptitude professionnelle agricole – CAPA, Brevet d'études professionnelles agricoles – BEPA",

        "0-1-1-4": "Baccalauréats professionnels, Baccalauréats technologiques, Brevet professionnels, Brevet des métiers d'art, Brevet de technicien",

        "0-1-1-5": "Brevet de technicien supérieur – BTs, Brevet de technicien supérieur agricole – BTSA, Diplôme universitaire de technologie – DUT, Brevets de maîtrise – Chambre des métiers",

        "0-1-1-6": "Licences, Licence professionnelle",

        "0-1-1-7": "Master - Titre d'ingénieur",

        "0-1-1-8": "-Doctorats",

        "0-2-1-11": "Culture de céréales (à l'exception du riz), de légumineuses et de graines oléagineuses", 

        "0-2-1-12": "Culture du riz", 

        "0-2-1-13": "Culture de légumes, de melons, de racines et de tubercules",

        "0-2-1-14": "Culture de la canne à sucre", 

        "0-2-1-15": "Culture du tabac", 

        "0-2-1-16": "Culture de plantes à fibres", 

        "0-2-1-17": "Autres cultures non permanentes", 

        "0-2-1-21": "Culture de la vigne", 

        "0-2-1-22": "Culture de fruits tropicaux et subtropicaux", 

        "0-2-1-23": "Culture d'agrumes", 

        "0-2-1-24": "Culture de fruits à pépins et à noyau", 

        "0-2-1-25": "Culture d'autres fruits d'arbres ou d'arbustes et de fruits à coque", 

        "0-2-1-26": "Culture de fruits oléagineux", 

        "0-2-1-27": "Culture de plantes à boissons", 

        "0-2-1-28": "Culture de plantes à épices, aromatiques, médicinales et pharmaceutiques", 

        "0-2-1-29": "Autres cultures permanentes",  

        "0-2-1-30": "Reproduction de plantes", 

        "0-2-1-41": "Élevage de vaches laitières", 

        "0-2-1-42": "Élevage d'autres bovins et de buffles", 

        "0-2-1-43": "Élevage de chevaux et d'autres équidés", 

        "0-2-1-44": "Élevage de chameaux et d'autres camélidés", 

        "0-2-1-45": "Élevage d'ovins et de caprins", 

        "0-2-1-46": "Élevage de porcins", 

        "0-2-1-47": "Élevage de volailles", 

        "0-2-1-48": "Élevage d'autres animaux", 

        "0-2-1-50": "Culture et élevage associés", 

        "0-2-1-61": "Activités de soutien aux cultures", 

        "0-2-1-62": "Activités de soutien à la production animale", 

        "0-2-1-63": "Traitement primaire des récoltes ", 

        "0-2-1-64": "Traitement des semences", 

        "0-2-1-70": "Chasse, piégeage et services annexes", 

        "1-3-1-1" : "expérience en matière d'éducation",

        "1-3-1-2" : "le bénévolat",

        "1-3-1-3" : "d'autres expériences",

        "1-4-1-1" : "moins de 3 ans",

        "1-4-1-2" : "plus de 3 ans",

    },

    results: {

        "1-1": "Même si vous avez déjà quelques expériences antérieures dans l'agriculture en tant qu'entrepreneur, notre plateforme FARMER 4.0 pourrait vous aider à approfondir certains concepts importants pour votre réussite en tant qu'agriculteurs 4.0. Quoi qu'il en soit, quelle est votre propension à l'entreprenariat et qu'en est-il de vos compétences entrepreneuriales ?",

        "1-2": "Comme vous n'avez pas d'expérience en tant qu'entrepreneur dans le secteur agricole, il est important de comprendre tout d'abord votre propension à entreprendre et si vous devez acquérir certaines compétences techniques ou humaines pour réussir dans le domaine où vous souhaitez travailler. À cet égard, nous pouvons dire que.",

        "1-4": {

            score: {

                "0-1": "Même si vous avez fait d'autres expériences (que professionnelles) en agriculture, ce genre d'expériences pourrait ne pas être assez longues (en terme de temps) ou récentes, il est donc important de comprendre tout d'abord votre réelle propension à l'entreprenariat et si vous possédez le bon niveau de compétences nécessaires pour réussir en tant qu'AGRICULTEUR 4.0. À cet égard, nous pouvons dire que.",

                "2" : "Même si vous avez fait des expériences récentes et importantes (autres que professionnelles) dans l'agriculture, vous n'avez pas du tout d'expérience en tant qu'entrepreneur, il est donc important de comprendre tout d'abord votre réelle propension à l'entreprenariat et si vous possédez le bon niveau de compétences nécessaires pour réussir en tant que 4.0 FARMER. À cet égard, nous pouvons dire que"

            }

        },

        "2": {

            score: {

            "39": "Vous devriez probablement éviter l'entrepreneuriat. Nous vous suggérons un entretien avec un évaluateur pour vérifier vos attentes réelles.",

            "59": "Le travail indépendant/l'entrepreneuriat n'est peut-être pas une carrière appropriée pour vous. Nous vous suggérons un entretien avec un évaluateur pour vérifier vos attentes réelles.",

            "79" : "Il semble que vous ayez des capacités satisfaisantes pour être un entrepreneur.",

            "100": "Il semble que vous ayez des capacités exceptionnelles pour être un entrepreneur.",

            }

        },

        "3-1": {

            score: {

            "44": "La créativité est pour vous une source d'irritation. Vous ne voyez aucune opportunité dans la créativité. Vous évitez les situations où vous devez être créatif. Vous préférez travailler de manière structurée et logique. Vous n'aimez pas les situations qui changent beaucoup ou le processus de prise de décision. Si vous voulez réussir dans l'agriculture 4.0, nous vous suggérons d'améliorer votre créativité (c'est-à-dire de suivre un cours sur cette compétence non-technique ou de demander de l'aide à un formateur/mentor).",

            "64": "La créativité est un devoir pour vous. Vous préférez un emploi où vous savez quelles tâches accomplir et où vous devez rarement faire preuve de créativité. Toutefois, lorsque la situation l'exige, vous êtes capable de trouver des solutions alternatives. Vous pouvez développer votre créativité en étant plus flexible. Si vous voulez réussir dans l'agriculture 4.0, nous vous suggérons d'améliorer votre créativité (c'est-à-dire de suivre un cours sur cette compétence non-technique ou de demander de l'aide à un formateur/mentor).",

            "84" : "Pour vous, la créativité est nécessaire. La créativité n'est pas un problème pour vous, mais elle est souvent nécessaire. Faire les choses d'une manière nouvelle est une valeur et parfois une nécessité. Vous pensez que parfois la solution doit être trouvée dans le \"non connu\". Vous êtes capable de trouver un équilibre entre des procédures fixes et une ouverture aux alternatives. Soyez conscient que vous devez toujours être minutieux lorsque vous effectuez un travail de routine. C'est une bonne chose pour ceux qui veulent réussir dans l'agriculture 4.0.",

            "100": "La créativité est un plaisir pour vous. Vous avez beaucoup d'idées et vous êtes toujours prêt à trouver de nouvelles inspirations, de nouvelles idées et de nouveaux projets. Vous devez être dans un environnement qui stimule votre créativité et votre fantaisie, sinon vous vous ennuyez et ne vous sentez pas assez valorisé. Mais attention : l'intuition est nécessaire, mais pas suffisante! C'est une bonne chose pour ceux qui veulent réussir dans l'agriculture 4.0."

            }

        },

        "3-2": {

            score: {

            "2": "Vous n'êtes pas très déterminé (à court terme) et que vous faites preuve d'un manque de cohérence pour atteindre vos objectifs (à moyen et long terme). Ce n'est pas bon pour qui veut travailler comme un entrepreneur à succès dans l'agriculture : en fait, l'une des caractéristiques les plus importantes des entrepreneurs est la détermination. Ce trait est étroitement lié à la confiance en soi. Plus vous croyez en vous, plus vous avez de chances de continuer à lutter pour le succès lorsque vous êtes confronté à d'énormes obstacles. Il faut de la détermination pour surmonter les problèmes qui assaillent toute nouvelle entreprise. Veuillez considérer la nécessité d’améliorer votre capacité à être déterminé et cohérent dans la réalisation de vos objectifs (c'est-à-dire suivre un cours sur ces compétences non techniques ou demander de l'aide à un formateur/mentor).",

            "5": "Vous n'êtes pas toujours déterminé (à court terme) et que parfois vous pouvez ne pas être cohérent dans la réalisation de vos objectifs (moyen à long terme). Ce n'est pas bon pour qui veut travailler comme entrepreneur à succès dans l'agriculture : en fait, l'une des caractéristiques les plus importantes des entrepreneurs est la détermination. Ce trait est étroitement lié à la confiance en soi. Plus vous croyez en vous, plus vous avez de chances de continuer à lutter pour le succès lorsque vous êtes confronté à d'énormes obstacles. Il faut de la détermination pour surmonter les problèmes qui assaillent toute nouvelle entreprise. Veuillez considérer la nécessité d’améliorer votre capacité à être déterminé et cohérent dans la réalisation de vos objectifs (c'est-à-dire suivre un cours sur ces compétences non techniques ou demander de l'aide à un formateur/mentor).",

            "6" : "Vous êtes très déterminé (à court terme) et vous êtes très cohérent lorsque vous essayez d'atteindre vos objectifs (à moyen et long terme). C'est excellent pour un entrepreneur dans le domaine de l'agriculture.",

            "9": "Vous avez une légère tendance à dévaloriser l'action des autres et à montrer des sentiments négatifs envers la personne qui agit plutôt que l'action elle-même. Ce n'est pas bon pour qui veut travailler comme un entrepreneur prospère dans l'agriculture. Veuillez considérer la nécessité d'améliorer votre capacité à collaborer davantage avec les autres (c'est-à-dire suivre un cours sur ces compétences non techniques ou demander de l'aide à un formateur/mentor).",

            "12": "En général, vous avez tendance à dévaloriser l'action des autres et à manifester des sentiments négatifs envers la personne qui agit plutôt qu'envers l'action elle-même. Ce n'est pas bon pour qui veut travailler comme un entrepreneur prospère dans l'agriculture. Veuillez considérer la nécessité d'améliorer votre capacité à collaborer davantage avec les autres (c'est-à-dire suivre un cours sur ces compétences non techniques ou demander de l'aide à un formateur/mentor).",

            }

        },

        "3-3": {

            score: {

            "2": "En général, vous avez une forte tendance à ne pas vous sentir responsable de vos actes : les entrepreneurs qui réussissent ont un centre  de contrôle interne ou un sens intérieur de la responsabilité pour le résultat d'une entreprise. Pour être un entrepreneur, vous devez avoir le sentiment d'être un \"vainqueur\" responsable de vos actes. Toutefois, si vous vous considérez souvent comme une \"victime\" et que vous blâmez les autres, la malchance ou des circonstances difficiles pour vos échecs, l'entrepreneuriat n'est peut-être pas la bonne orientation de carrière pour vous. Nous vous suggérons de travailler sur cette question (c'est-à-dire de suivre un cours sur ces compétences non techniques ou de demander de l'aide à un formateur/mentor).",

            "5": "En général, vous avez une tendance modérée à vous sentir responsable de vos actes : les entrepreneurs qui réussissent ont un centre de contrôle interne ou un sens intérieur de responsabilité pour le résultat d'une entreprise. Pour être un entrepreneur, vous devez avoir le sentiment d'être un \"vainqueur\" responsable de vos actes. Toutefois, si vous vous considérez souvent comme une \"victime\" et que vous blâmez les autres, la malchance ou des circonstances difficiles pour vos échecs, l'entrepreneuriat n'est peut-être pas la bonne orientation de carrière pour vous. Nous vous suggérons de travailler sur cette question (c'est-à-dire de suivre un cours sur ces compétences non techniques ou de demander de l'aide à un formateur/mentor).",

            "6" : "Vous montrez une tendance suffisante à vous sentir responsable et donc une propension tout aussi suffisante à vous engager pour atteindre les objectifs : les entrepreneurs qui réussissent ont un centre de contrôle interne ou un sentiment de responsabilité interne pour le résultat d'une entreprise. Pour être un entrepreneur, vous devez avoir le sentiment d'être un \"vainqueur\" responsable de vos actes. Toutefois, si vous vous considérez souvent comme une \"victime\" et que vous blâmez les autres, la malchance ou des circonstances difficiles pour vos échecs, l'entrepreneuriat n'est peut-être pas la bonne orientation de carrière pour vous. Nous vous invitons à améliorer votre capacité à vous affirmer (c'est-à-dire à suivre un cours sur ces compétences non techniques ou à demander l'aide d'un formateur/mentor).",

            "9": "Vous montrez une bonne tendance à vous sentir responsable et donc une propension tout aussi bonne à vous engager pour atteindre les objectifs. C'est une bonne chose pour qui veut être un entrepreneur à succès dans l'agriculture.",  

            "12": "Vous montrez votre excellente tendance à vous sentir responsable et donc une propension tout aussi excellente à vous engager pour atteindre les objectifs. C'est excellent pour qui veut être un entrepreneur à succès dans l'agriculture.",  

            }

        },

        "3-4": {

            score: {

            "2": "Vous pouvez avoir tendance à tout contrôler (manque de capacité de sélection) et confondre les objectifs à court terme avec les objectifs à long terme, ce qui peut vous amener à être submergé par les délais. Cette situation doit être améliorée (c'est-à-dire en suivant un cours sur ces compétences non techniques ou en demandant de l'aide à un formateur/mentor), car les entrepreneurs prennent des risques. Ils risquent leur carrière, leur temps et leur argent pour assurer le succès de leur entreprise. Pour réussir en tant qu'indépendant, vous devez vous sentir à l'aise pour prendre des risques raisonnables.",

            "5": "Il peut être difficile pour vous d'établir des priorités et vous ne serez pas toujours en mesure de faire la distinction entre les questions très urgentes et non urgentes. Cela peut conduire à des situations très stressantes. Les entrepreneurs sont des preneurs de risques. Ils risquent leur carrière, leur temps et leur argent pour assurer le succès de leur entreprise. Pour réussir en tant qu'indépendant, vous devez vous sentir à l'aise de prendre des risques raisonnables. Cette situation doit être améliorée (c'est-à-dire en suivant un cours sur ces compétences non techniques ou en demandant de l'aide à un formateur/mentor).",

            "6" : "Vous avez une grande capacité à hiérarchiser les objectifs et pouvez distinguer les questions très urgentes des questions non urgentes, comme c'est le cas pour un entrepreneur.",

            "9": "Vous avez des difficultés à accomplir vos tâches quotidiennes et à atteindre vos objectifs. D'ailleurs, les entrepreneurs ont un fort besoin de réussite. Ils s'efforcent d'exceller et d'atteindre des objectifs assez élevés. Vous devez être prêt à vous fixer des objectifs élevés et prendre plaisir à les atteindre. En tenant compte de cet élément, vous devez améliorer votre capacité à (c'est-à-dire suivre un cours sur ces compétences non techniques ou demander de l'aide à un formateur/mentor). ",

            "12": "Vous avez des difficultés à accomplir vos tâches quotidiennes et à atteindre vos objectifs. Toutefois, cette situation peut être améliorée (c'est-à-dire en suivant un cours sur ces compétences non techniques ou en demandant de l'aide à un formateur/mentor), car les entrepreneurs prennent des risques. Ils risquent leur carrière, leur temps et leur argent pour assurer le succès de leur entreprise. Pour réussir en tant qu'indépendant, vous devez vous sentir à l'aise pour prendre des risques raisonnables.",

            }

        },

        "3-5": {

            score: {

            "2": "Vous avez une forte capacité à \"faire soi-même\", sans aucune aide des autres et à agir sur votre propre direction/initiative/moteur. Mais il est parfois nécessaire de consulter d'autres professionnels pour obtenir des conseils, des informations et des références si vous voulez atteindre le succès. Nous vous suggérons donc d'améliorer votre capacité à atteindre vos objectifs professionnels en impliquant d'autres interlocuteurs.",

            "5": "Vous avez une capacité moyenne à travailler de votre propre initiative/votre propre volonté/votre propre capacité sans demander l'aide des autres. Mais parfois, cela peut ne pas suffire. Nous vous suggérons donc d'améliorer votre capacité à atteindre vos objectifs professionnels en impliquant d'autres interlocuteurs.",

            "6" : "Vous êtes tout à fait capable de travailler de votre propre initiative/aptitude/conduite, mais vous savez aussi quand accepter l'aide d'autres personnes et c'est excellent pour quelqu'un comme vous qui veut atteindre des objectifs professionnels impliquant d'autres interlocuteurs.",

            "9": "Bien que vous ayez une capacité moyenne à assigner des tâches, vous dépendez parfois trop de l'aide des autres et de beaucoup d'informations pour appuyer votre décision. Nous vous proposons donc d'améliorer votre capacité à atteindre vos objectifs professionnels en impliquant d'autres interlocuteurs sans arriver à les manipuler.",

            "12": "Bien que vous soyez très capable de répartir les tâches, vous avez tendance à demander trop d'aide et à rechercher trop d'informations pour étayer vos décisions, ce qui pourrait vous nuire. Nous vous suggérons donc d'améliorer votre capacité à atteindre vos objectifs professionnels en impliquant d'autres interlocuteurs sans arriver à les manipuler.",

            }

        },

        "4-1": {

            score: {

            "5": "Si vous voulez être capable d'utiliser les outils de FARMER 4.0, vous devez étendre/élargir/développer vos connaissances générales sur les TIC en suivant un cours (au moins de niveau de base)",

            "8": "Si vous voulez être capable d'utiliser correctement les outils FARMER 4.0, vous pouvez améliorer vos connaissances en suivant un cours (niveau moyen)",

            "10" : "Félicitations : vos connaissances générales en TIC sont avancées et vous n'aurez aucun problème à utiliser les outils et modèles FARMER 4.0.",

            }

        },

        

        "4-2-1": {

            "yes":"Même si vous êtes déjà capable de travailler en CAO, nous vous invitons à consulter le module CAO/FAO/CAE/RE sur la plate-forme FARMER 4.0",

            "no": "Vous devez suivre le module CAO sur la plate-forme FARMER 4.0",

        },

        "4-2-2": {

            "yes": "Même si vous êtes déjà capable de travailler en CAE, nous vous invitons à consulter le module CAO/FAO/CAE/RE sur la plate-forme FARMER 4.0",

            "no": "Vous devez suivre le module CAE sur la plateforme FARMER 4.0",

        },

        "4-2-3": {

            "yes": "Même si vous êtes déjà capable de travailler dans la FAO, nous vous invitons à jeter un coup d'œil au module CAO/FAO/CAE/RE sur la plate-forme FARMER 4.0",

            "no": "Vous devez suivre le module CAM sur la plateforme FARMER 4.0",

        },

        "4-2-4": {

            "yes": "Même si vous êtes déjà capable de travailler dans le domaine des ER, nous vous invitons à jeter un coup d'œil au module CAO/FAO/RE sur la plate-forme FARMER 4.0",

            "no": "Vous devez suivre le module RE sur la plateforme FARMER 4.0",

        },

        "4-2-5": {

            "yes": "Même si vous êtes déjà capable de travailler dans la fabrication d'additifs, nous vous invitons à consulter le module Additive Manufacturing - 3D Print sur la plateforme FARMER 4.0",

            "no": "Vous devez suivre le module Additive Manufacturing - 3D Print sur la plateforme FARMER 4.0",

        },

        "4-2-6": {

            "yes": "Même si vous pouvez déjà utiliser les médias sociaux (c'est-à-dire facebook, Instagram, Pinterest...) ou un site web pour vous présenter et présenter votre exploitation/activités ou vendre vos produits, nous vous invitons à consulter les modules \"Social Networking for the Global Farm 4.0\" et \"On line communication tools and techniques\" sur la plate-forme FARMER 4.0",

            "no": "Vous devez suivre les modules \"Social Networking for the Global Farm 4.0\ et \"On line communication tools and techniques\" sur la plateforme FARMER 4.0",

        },

        "5-1": {

            "yes": "Même si vous êtes déjà capable de travailler avec une approche FabLab et que vous connaissez très bien la numérisation en agriculture, nous vous invitons à consulter le module \"Entrepreneuriat agricole basé sur l'approche FabLab\" sur la plateforme FARMER 4.0",

            "no": "Vous êtes tenu de suivre le module \"Entrepreneuriat agricole basé sur l'approche FabLab\" sur la plateforme FARMER 4.0",

        },

        "5-2": {

            "yes": "Même si vous êtes déjà en mesure de travailler dans un contexte international, nous vous invitons à consulter le module \"Internationalisation et durabilité de l'agriculture mondiale 4.0\" sur la plateforme FARMER 4.0",

            "no": "Vous êtes tenu de suivre le module \"Internationalisation et durabilité de la Global Farm 4.0\" sur la plateforme FARMER 4.0",

        },

        "5-3": {

            "yes": "Même si vous travaillez pour la durabilité de l'agriculture, nous vous invitons à consulter le module \"Internationalisation et durabilité de l'agriculture mondiale 4.0\" sur la plateforme FARMER 4.0",

            "no": "Vous devez suivre le module \"Internationalisation et durabilité de la Global Farm 4.0\" sur la plateforme FARMER 4.0"

        }

    }

}

